import { render } from "./CostsList.vue?vue&type=template&id=7b20e66c&scoped=true"
import script from "./CostsList.vue?vue&type=script&lang=js"
export * from "./CostsList.vue?vue&type=script&lang=js"

import "./CostsList.vue?vue&type=style&index=0&id=7b20e66c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b20e66c"]])

export default __exports__